export const statusDataList = ["Active", "Inactive"].reduce((acc, val) => {
  let key = val.toLocaleLowerCase();
  let value = val;
  acc.push({ key, value });
  return acc;
}, []);

export const MONTHS = [
  "",
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const priceTypes = [
  "Per member",
  "Per adult",
  "Per couple",
  "Per family",
];

export const shippingOptions = [
  { value: "pickup", label: "Pick up only" },
  { value: "shipping", label: "Shipping only" },
  { value: "both", label: "Option of shipping or pickup" },
  { value: "none", label: "Not applicable" },
];

export const productChoices = [
  "None",
  "1 per member",
  "1 per adult",
  "1 per package",
];

export const allTshirtSizes = [
  "Youth Small",
  "Youth Medium",
  "Youth Large",
  "Youth XL",
  "Adult XS",
  "Adult Small",
  "Adult Medium",
  "Adult Large",
  "Adult XL",
  "Adult 2XL",
  "Adult 3XL",
  "Women's XS",
  "Women's Small",
  "Women's Medium",
  "Women's Large",
  "Women's XL",
  "Women's 2XL",
];

export const CALENDAR_BASED_LEAGUES = [
  "253", // MLS
  "254", // NWSL
  "255", // USL Championship
  "489", // USL League One
  "256", // USL League Two
  "479", // CPL
  "71", // Seria A (Brazil)
  "666", // Friendlies Women
  "10", // Friendlies
  "1", // World Cup
  "8", // World Cup
  //135,
];
